<template>
  <CBox
    v-if="detalhePrestador"
    :bg="['none', 'var(--colors-light-primary-light-gray)']"
    minHeight="100vh"
    width="100vw"
    class="doctors-info-print"
  >
    <OmtLayoutContainer bg="#F1F2F4">
      <OmtRow mb="18px" :mx="['-16px', '-40px']" px="16px">
        <CFlex bg="#FFFFFF" p="16px" borderRadius="8px" flexDirection="column" gap="8px">
          <CFlex align-items="center" mb="8px">
            <CFlex width="80%" mr="auto" align-items="center">
              <OmtTypography as="button-medium">{{ name }}</OmtTypography>
            </CFlex>
            <CFlex>
              <OmtIcons mr="16px" size="1x" name="share-nodes" cursor="pointer" @click="printScreen" />
              <OmtIcons
                :prefix="favorite ? 'fas' : 'fa-light'"
                :color="favorite ? 'var(--colors-light-primary-navy-blue)' : ''"
                size="1x"
                name="heart"
                v-on:click.prevent="changeFavorite"
                cursor="pointer"
              />
            </CFlex>
          </CFlex>
          <CFlex
            v-if="
              detalhePrestador && (detalhePrestador.Avaliacao || detalhePrestador.Distancia || detalhePrestador.TpRede)
            "
            align-items="center"
            mb="16px"
          >
            <!-- <CFlex align-items="center" v-if="detalhePrestador.Avaliacao">
              <OmtIcons mr="4px" size="1x" prefix="fa-sharp" name="star" color="var(--colors-light-support-warning)" />
              <OmtTypography as="h3-semi-bold" ml="4px" color="var(--colors-light-support-warning)">
                {{ notaFormatada }}
              </OmtTypography>
              <OmtTypography as="p2" ml="4px" color="var(--colors-light-primary-gray2)">
                ({{ detalhePrestador.QuantidadeAvaliacoes || 0 }})
              </OmtTypography>
            </CFlex> -->

            <CFlex align-items="center" v-if="detalhePrestador.Distancia || detalhePrestador.TpRede">
              <CBox mx="8px" display="flex" align-items="center" v-if="detalhePrestador.Avaliacao">
                <OmtTypography as="h3-semi-bold" color="var(--colors-light-primary-gray2)">
                  <b>•</b>
                </OmtTypography>
              </CBox>

              <OmtTypography as="p2" color="var(--colors-light-primary-gray2)">
                <template v-if="detalhePrestador.Distancia"> {{ detalhePrestador.Distancia }} km </template>
                <template v-if="detalhePrestador.Distancia && detalhePrestador.TpRede">
                  <b style="margin-left: 4px; margin-right: 4px">•</b>
                </template>
                <template v-if="detalhePrestador.TpRede">
                  {{ detalhePrestador.TpRede }}
                </template>
              </OmtTypography>
            </CFlex>
          </CFlex>
          <CFlex v-if="detalhePrestador.PossuiAgendaOnline" mb="24px">
            <OmtButton
              height="auto"
              py="8px"
              w="100%"
              backgroundColor="transparent"
              color="var(--colors-light-primary-gray1)"
              border="1px solid var(--colors-light-secondary-divider)"
              borderRadius="24px"
              @click="() => goTo(detalhePrestador.UrlAgenda)"
            >
              <CBox display="inline-flex" align-items="center" mr="2">
                <FontAwesomeIcon icon="fa-light fa-calendar" size="1x" />
              </CBox>
              <OmtTypography as="h3-bold">Agenda online</OmtTypography>
            </OmtButton>
          </CFlex>
          <CFlex v-if="detalhePrestador.PossuiWhatsapp" mb="24px">
            <OmtButton
              height="auto"
              py="8px"
              w="100%"
              backgroundColor="transparent"
              color="var(--colors-light-primary-gray1)"
              border="1px solid var(--colors-light-secondary-divider)"
              borderRadius="24px"
              @click="() => redirectWhats(detalhePrestador.TelefoneWhatsapp)"
            >
              <OmtIcons size="1x" name="whatsapp" mr="2" color="var(--colors-light-support-success)" />
              <OmtTypography as="h3-bold">Agendar por WhatsApp</OmtTypography>
            </OmtButton>
          </CFlex>
          <CFlex flexWrap="wrap">
            <CBox
              v-for="(tel, index) in telefonesCard"
              :key="`header-tel-${index}`"
              as="a"
              :href="phoneLink(tel)"
              cursor="pointer"
              border="1px solid var(--colors-light-secondary-divider)"
              borderRadius="24px"
              px="12px"
              py="6px"
              mr="16px"
              mb="8px"
              display="flex"
              alignItems="center"
            >
              <OmtIcons size="1x" name="phone" mr="2" />
              <OmtTypography as="h3-bold">{{ tel }}</OmtTypography>
            </CBox>
          </CFlex>
        </CFlex>
      </OmtRow>

      <!--  Atenção: Este prestador faz parte de uma rede complementar parceira -->
      <OmtRow v-if="detalhePrestador.ExibeAlertaRedeComplementar" :mx="['-16px', '-40px']" px="16px">
        <CBox
          mb="24px"
          p="16px"
          bg="#EBF0FE"
          border="0.5px solid var(--colors-light-primary-navy-blue)"
          border-radius="8px"
        >
          <CFlex align-items="flex-start" mb="16px">
            <OmtIcons name="circle-exclamation" size="lg" color="var(--colors-light-primary-navy-blue)" mr="8px" />
            <OmtTypography as="h3-bold" color="var(--colors-light-primary-navy-blue)">
              {{ detalhePrestador.TituloAlertaRedeComplementar || "" }}
            </OmtTypography>
          </CFlex>

          <OmtTypography as="p1" color="var(--colors-light-primary-gray1)" mb="16px">
            {{ detalhePrestador.TextoAlertaRedeComplementar || "" }}
          </OmtTypography>

          <CBox bg="#FFFFFF" p="16px" border-radius="8px">
            <CFlex
              align-items="center"
              pb="16px"
              border-bottom="1px solid var(--colors-light-secondary-divider)"
              mb="16px"
            >
              <OmtIcons name="address-card" size="lg" mr="8px" color="var(--colors-light-primary-gray1)" />
              <OmtTypography as="h3-bold" color="var(--colors-light-primary-gray1)">
                {{ detalhePrestador.PlanoAtendimentoRede || "" }}
              </OmtTypography>
            </CFlex>

            <CFlex direction="column">
              <OmtTypography as="p1" color="var(--colors-light-primary-gray1)">
                <span style="font-weight: 600">Credencial:</span> {{ detalhePrestador.CredencialAtendimentoRede || "" }}
              </OmtTypography>
              <OmtTypography as="p1" color="var(--colors-light-primary-gray1)">
                <span style="font-weight: 600">Padrão:</span> {{ detalhePrestador.PadraoAtendimentoRede || "" }}
              </OmtTypography>
            </CFlex>
          </CBox>
        </CBox>
      </OmtRow>

      <OmtRow mb="16px" :mx="['-16px', '-40px']" px="16px">
        <OmtTypography as="h3-bold"> Como chegar </OmtTypography>
      </OmtRow>

      <OmtRow :mx="['-16px', '-40px']" px="16px">
        <CFlex display="flex" flexDirection="column">
          <OmtRow bg="#FFFFFF" p="16px" borderRadius="8px" mb="24px">
            <CFlex flexDirection="column" width="100%">
              <OmtRow v-if="address1" mb="16px">
                <CFlex>
                  <OmtTypography as="p1">{{ address1 }} - {{ address2 }}</OmtTypography>
                </CFlex>
              </OmtRow>
              <OmtRow gap="16px">
                <CFlex
                  flex="0 0 145px"
                  w="145px"
                  minW="145px"
                  maxW="145px"
                  h="40px"
                  minH="40px"
                  maxH="40px"
                  borderRadius="32px"
                  border="1px solid var(--colors-light-primary-light-gray)"
                  justifyContent="center"
                  alignItems="center"
                  cursor="pointer"
                  @click="
                    goTo(
                      `https://www.google.com/maps/search/?api=1&query=${detalhePrestador.Endereco.Latitude}%2C${detalhePrestador.Endereco.Longitude}`
                    )
                  "
                >
                  <img :src="googleMaps" alt="maps" style="height: 17px" />
                </CFlex>
                <CFlex
                  flex="0 0 145px"
                  w="145px"
                  minW="145px"
                  maxW="145px"
                  h="40px"
                  minH="40px"
                  maxH="40px"
                  borderRadius="32px"
                  bgColor="#15CCFF"
                  style="-webkit-print-color-adjust: exact; print-color-adjust: exact"
                  justifyContent="center"
                  alignItems="center"
                  gap="2px"
                  cursor="pointer"
                  @click="
                    goTo(
                      `https://www.waze.com/ul?ll=${detalhePrestador.Endereco.Latitude}%2C${detalhePrestador.Endereco.Longitude}&navigate=yes&zoom=17`
                    )
                  "
                >
                  <img :src="waze" alt="waze" style="height: 12px" />
                  <img :src="wazeIcon" />
                </CFlex>
              </OmtRow>
            </CFlex>
          </OmtRow>
        </CFlex>
      </OmtRow>

      <template v-if="facilidades.length > 0">
        <OmtRow mb="16px" :mx="['-16px', '-40px']" px="16px">
          <OmtTypography as="h3-bold"> Facilidades </OmtTypography>
        </OmtRow>

        <OmtRow :mx="['-16px', '-40px']" px="16px">
          <OmtRow bg="#FFFFFF" p="16px" borderRadius="8px" mb="24px">
            <CFlex display="flex" flexDirection="column">
              <CList styleType="disc" class="doctor-spec-list">
                <CListItem v-for="(e, i) in facilidades" :key="`acc-${i}`">
                  <template v-if="e === teleconsulta">
                    <CFlex display="inline-flex">
                      <OmtTypography display="inline-flex" as="p1">{{ e }}</OmtTypography>
                      <OmtIcons name="video" ml="12px" />
                    </CFlex>
                  </template>
                  <OmtTypography v-else display="inline-flex" as="p1">{{ e }}</OmtTypography>
                </CListItem>
              </CList>
            </CFlex>
          </OmtRow>
        </OmtRow>
      </template>

      <OmtRow v-if="notaFormatada && false" mb="24px">
        <CFlex justifyContent="space-between">
          <CBox display="inline-flex" alignItems="center">
            <OmtIcons size="1x" prefix="fa-sharp" name="star" mr="2" color="var(--colors-light-support-warning)" />
            <OmtTypography as="h3-bold" color="var(--colors-light-support-warning)">{{ notaFormatada }}</OmtTypography>
          </CBox>
          <CBox v-if="match.Avaliacoes">
            <OmtTypography as="p1">{{ match.Avaliacoes }} avaliações</OmtTypography>
          </CBox>
        </CFlex>
      </OmtRow>

      <OmtRow mb="24px" v-if="exibirWazeMaps" :mx="['-16px', '-40px']" px="16px">
        <CFlex justifyContent="space-between" width="100%">
          <CFlex
            width="45%"
            py="10px"
            border="1px solid var(--colors-light-secondary-divider)"
            borderRadius="8px"
            justifyContent="center"
            alignItems="center"
            @click="
              goTo(
                `https://www.google.com/maps/search/?api=1&query=${detalhePrestador.Endereco.Latitude}%2C${detalhePrestador.Endereco.Longitude}`
              )
            "
          >
            <img :src="googleMaps" alt="Google Maps" />
          </CFlex>
          <CFlex
            width="45%"
            py="10px"
            border="1px solid var(--colors-light-secondary-divider)"
            bgColor="#15CCFF"
            style="-webkit-print-color-adjust: exact; print-color-adjust: exact"
            borderRadius="8px"
            justifyContent="center"
            alignItems="center"
            @click="
              goTo(
                `https://www.waze.com/ul?ll=${detalhePrestador.Endereco.Latitude}%2C${detalhePrestador.Endereco.Longitude}&navigate=yes&zoom=17`
              )
            "
          >
            <img :src="waze" alt="Waze" />
            <img :src="wazeIcon" alt="" />
          </CFlex>
        </CFlex>
      </OmtRow>

      <template
        v-if="
          (detalhePrestador.Especialidades && detalhePrestador.Especialidades.length > 0) ||
          (curriculoItems && curriculoItems.length > 0) ||
          (detalhePrestador.Qualificacoes && detalhePrestador.Qualificacoes.length > 0) ||
          (idioms && idioms.length > 0) ||
          detalhePrestador.DivulgaQualificacoes ||
          (qualificacoesANS && qualificacoesANS.length > 0)
        "
      >
        <OmtRow mb="16px" :mx="['-16px', '-40px']" px="16px">
          <OmtTypography as="h3-bold">Sobre o prestador</OmtTypography>
        </OmtRow>
        <OmtRow mb="24px" :mx="['-16px', '-40px']" px="16px">
          <CBox bg="#FFFFFF" borderRadius="8px" p="16px" w="100%">
            <CFlex flexDirection="column">
              <template v-if="detalhePrestador.Especialidades && detalhePrestador.Especialidades.length > 0">
                <OmtTypography as="h3-bold" mb="8px">Especialidades</OmtTypography>
                <CList styleType="disc" pl="8px" class="doctor-spec-list">
                  <CListItem v-for="(e, i) in detalhePrestador.Especialidades" :key="`spec-${i}`">
                    <OmtTypography as="p1" display="inline-flex">
                      {{ e.trim() }}
                    </OmtTypography>
                  </CListItem>
                </CList>
              </template>

              <template
                v-if="
                  (curriculoItems && curriculoItems.length > 0) ||
                  (detalhePrestador.Qualificacoes && detalhePrestador.Qualificacoes.length > 0)
                "
              >
                <omt-divider my="16px" />
                <OmtTypography as="h3-bold" mb="12px">Currículo</OmtTypography>
                <CBox v-if="curriculoItems.length > 0">
                  <CList styleType="none" class="doctor-spec-list" pl="8px" mb="16px">
                    <CListItem v-for="(item, i) in curriculoItems" :key="'curriculo-' + i">
                      <OmtTypography as="p1">
                        <CBox
                          as="span"
                          display="inline-block"
                          vertical-align="middle"
                          w="3px"
                          h="3px"
                          bg="currentColor"
                          border-radius="50%"
                          mr="6px"
                        />
                        {{ item }}
                      </OmtTypography>
                    </CListItem>
                  </CList>
                </CBox>

                <!-- Qualificações dentro do Currículo -->
                <template v-if="detalhePrestador.Qualificacoes && detalhePrestador.Qualificacoes.length > 0">
                  <CList styleType="none" class="doctor-spec-list" pl="8px">
                    <CListItem v-for="(q, i) in detalhePrestador.Qualificacoes" :key="'qaa-' + i">
                      <OmtTypography as="p1">
                        <CBox
                          as="span"
                          display="inline-block"
                          vertical-align="middle"
                          w="3px"
                          h="3px"
                          bg="currentColor"
                          border-radius="50%"
                          mr="6px"
                        />
                        {{ q.Titulo }}
                      </OmtTypography>
                    </CListItem>
                  </CList>
                </template>
              </template>

              <template v-if="idioms && idioms.length > 0">
                <omt-divider my="16px" />
                <OmtTypography as="h3-bold" mb="8px">Idiomas</OmtTypography>
                <CList styleType="disc" pl="8px">
                  <CListItem v-for="(id, i) in idioms" :key="`lang-${i}`">
                    <OmtTypography display="inline-flex" as="p1">{{ id.trim() }}</OmtTypography>
                  </CListItem>
                </CList>
              </template>

              <template v-if="qualificacoesANS && qualificacoesANS.length > 0">
                <omt-divider my="16px" />
                <OmtTypography as="p2" mb="16px" v-if="detalhePrestador.TextoQualificacoes">
                  {{ detalhePrestador.TextoQualificacoes }}
                </OmtTypography>
                <CAccordion
                  :index="qualificacoesAccordionIndex"
                  :allowToggle="true"
                  border="1px solid var(--colors-light-secondary-divider)"
                  p="16px"
                  borderRadius="8px"
                  bg="white"
                  @change="qualificacoesAccordionIndex = $event === null ? -1 : $event"
                >
                  <CAccordionItem bg="white" borderColor="transparent" class="accordion-item">
                    <PanelTitle title="">
                      <template #header>
                        <OmtTypography as="p1">Qualificações - IN 52</OmtTypography>
                      </template>
                    </PanelTitle>
                    <CAccordionPanel px="0" pb="0">
                      <CList styleType="none" pl="0">
                        <CListItem v-for="(q, i) in qualificacoesANS" :key="'qans-' + i" mb="12px">
                          <CFlex align-items="center">
                            <CBox w="24px" minW="24px" mr="12px">
                              <img :src="q.src" :alt="q.name" />
                            </CBox>
                            <OmtTypography as="p2" color="var(--colors-light-primary-gray2)">{{ q.dsc }}</OmtTypography>
                          </CFlex>
                        </CListItem>
                      </CList>
                    </CAccordionPanel>
                  </CAccordionItem>
                </CAccordion>

                <template v-if="redesSociais.length > 0">
                  <OmtRow>
                    <omt-divider />
                  </OmtRow>

                  <OmtRow>
                    <OmtTypography mb="8px" as="h3-bold">Redes sociais</OmtTypography>
                  </OmtRow>

                  <OmtRow>
                    <CFlex>
                      <CBox
                        v-for="(r, i) in redesSociais"
                        :key="'redesocial-' + i"
                        :mr="i < redesSociais.length - 1 ? '24px' : '0'"
                      >
                        <OmtButton
                          :disabled="!r.Link"
                          h="24px"
                          max-h="24px"
                          min-w="24px"
                          background="transparent"
                          :opacity="r.Link ? '1' : '0.4 !important'"
                          ps="0"
                          pe="0"
                          border="1px solid var(--colors-light-primary-gray1)"
                          borderRadius="100%"
                          @click="goToRedeSocial(r)"
                        >
                          <OmtIcons prefix="fa-brands" size="1x" :name="r.Tipo" />
                        </OmtButton>
                      </CBox>
                    </CFlex>
                  </OmtRow>
                </template>
              </template>
            </CFlex>
          </CBox>
        </OmtRow>
      </template>

      <OmtRow mb="24px" v-if="detalhePrestador.ExibePlanosAtendidos" :mx="['-16px', '-40px']" px="16px">
        <CFlex
          bg="#FFFFFF"
          p="16px"
          borderRadius="8px"
          align="center"
          justify="space-between"
          @click="() => showPlansAttended()"
        >
          <OmtTypography as="p1">Consultar planos atendidos</OmtTypography>
          <FontAwesomeIcon color="#4E4E4E" icon="fa-light fa-angle-right" size="1x" />
        </CFlex>
      </OmtRow>

      <OmtRow mb="24px" v-if="inativo || sendoDescredenciado" :mx="['-16px', '-40px']" px="16px">
        <CFlex pb="4">
          <OmtButton pt="12px" pb="12px" w="100%" height="auto" @click="() => showSubstitutes()">
            <OmtTypography as="h3-bold" color="#FFF">Credenciados substitutos</OmtTypography>
          </OmtButton>
        </CFlex>
      </OmtRow>
    </OmtLayoutContainer>
  </CBox>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import ImagePreviewer from "@/components/Molecules/ImagePreviewer";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import { isMobile } from "@/utils/utils";
import { isLoggedIn } from "@/utils/authUtil";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import PanelTitle from "@/components/Organisms/RefundNew/topics/PanelTitle.vue";
import ConsultasPanel from "@/components/Organisms/RefundNew/topics/ConsultasPanel.vue";
import ExamesPanel from "@/components/Organisms/RefundNew/topics/ExamesPanel.vue";
import VacinasPanel from "@/components/Organisms/RefundNew/topics/VacinasPanel.vue";
import AcupunturaPanel from "@/components/Organisms/RefundNew/topics/AcupunturaPanel.vue";
import FisioterapiaPanel from "@/components/Organisms/RefundNew/topics/FisioterapiaPanel.vue";
import InternacoesPanel from "@/components/Organisms/RefundNew/topics/InternacoesPanel.vue";
import OdontologiaPanel from "@/components/Organisms/RefundNew/topics/OdontologiaPanel.vue";
import IconRow from "@/components/Atoms/icon-row.vue";

export default {
  name: "DoctorsInfo",
  components: {
    ImagePreviewer,
    FontAwesomeIcon,
    PanelTitle,
    ConsultasPanel,
    ExamesPanel,
    VacinasPanel,
    AcupunturaPanel,
    FisioterapiaPanel,
    InternacoesPanel,
    OdontologiaPanel,
    IconRow
  },
  data() {
    return {
      logado: false,
      inativo: false,
      sendoDescredenciado: false,
      favorite: false,
      pictures: [],
      detalhePrestador: null,
      qualificacoesAccordionIndex: -1
    };
  },
  async mounted() {
    await this.$root.$emit("show-loading");
    try {
      this.logado = isLoggedIn();
      this.inativo = this.Situacao !== "A";
      if (!this.logado) {
        this.SET_REDE(this.RedeBusca);
      }

      const response = await this.obterDetalhesPrestador({
        prestador: this.CdPrestador,
        endereco: this.SrEndereco
      });

      if (response && response.Data) {
        this.detalhePrestador = response.Data;
        this.favorite = this.detalhePrestador.Favorito;
      } else {
        throw new Error(response?.message || "Ocorreu um erro ao buscar os detalhes do prestador.");
      }

      this.sendoDescredenciado = !!this.prestadoresSendoDescredenciados.find(
        a => a.codigoPrestadorDescredenciado === this.CdPrestador && a.srEnderecoDescredenciado === this.SrEndereco
      );

      if (!this.inativo) {
        this.addAffiliateView({
          prestador: this.CdPrestador,
          endereco: this.SrEndereco
        });
      }
    } catch (error) {
      await Swal.fire({
        text: error.message || "Ocorreu um erro ao buscar os detalhes do prestador.",
        confirmButtonText: "OK",
        icon: "error"
      });
      this.$router.replace({ name: "affiliate" });
    } finally {
      await this.$root.$emit("hide-loading");
    }
  },
  computed: {
    ...mapState("affiliate", ["rede", "locationType", "prestadoresSendoDescredenciados"]),
    ...mapState("saude", ["vinculo"]),
    ...mapGetters("saude", ["baseUrl"]),
    ...mapGetters("biometrics", ["onNative"]),
    exibirWazeMaps() {
      if (!this.vinculo) return false;

      return (
        !this.vinculo.startsWith("99999922") &&
        !this.vinculo.startsWith("25257130") &&
        this.v24 &&
        this.detalhePrestador?.Endereco?.Latitude &&
        this.detalhePrestador?.Endereco?.Longitude
      );
    },
    CdPrestador() {
      return this.$route.params.cdPrestador ?? "";
    },
    SrEndereco() {
      return this.$route.params.srEndereco ?? "";
    },
    Situacao() {
      return this.$route.params.situacao ?? "A";
    },
    RedeBusca() {
      return this.$route.params.rede ?? "";
    },
    isMobile() {
      return isMobile;
    },
    distanciaFormatada() {
      return "";
    },
    curriculoItems() {
      const curriculo = this.detalhePrestador?.Curriculo;

      if (typeof curriculo === "string") {
        const item = curriculo.trim();
        return item ? [item] : [];
      }

      const curriculoLista = Array.isArray(curriculo) ? curriculo : curriculo ? [curriculo] : [];

      return curriculoLista
        .filter(item => item?.Tipo === "Formação Acadêmica")
        .flatMap(item => item?.Registros || [])
        .map(item => (item === null || item === undefined ? "" : `${item}`.trim()))
        .filter(Boolean);
    },
    notaFormatada() {
      return this.detalhePrestador?.Avaliacao
        ? `${Math.round(this.detalhePrestador.Avaliacao * 10) / 10}`.replace(".", ",")
        : "";
    },
    primarySpecialty() {
      return this.detalhePrestador?.Especialidade ?? "Ortopedia Pediátrica";
    },
    ratingLabel() {
      const nota = this.notaFormatada || "4,9";
      const avaliacoes = this.detalhePrestador?.QuantidadeAvaliacoes ?? "105";
      return `${nota} • ${avaliacoes} avaliações`;
    },
    telefonesCard() {
      return this.detalhePrestador?.Telefones ?? [];
    },
    teleconsulta() {
      return "Atende também por teleconsulta";
    },
    facilidades() {
      return this.detalhePrestador?.Facilidades ?? [];
    },
    googleMaps() {
      return process.env.VUE_APP_BASE_URL + "images/omint/google-maps.svg";
    },
    waze() {
      return process.env.VUE_APP_BASE_URL + "images/omint/waze.png";
    },
    wazeIcon() {
      return process.env.VUE_APP_BASE_URL + "images/omint/waze-icon.png";
    },
    qualificacoesANS() {
      const qa = [
        {
          name: "Aona",
          dsc: "Padrão nacional de qualidade",
          src: `${this.baseUrl}/images/omint/busca/aona.jpg`
        },
        {
          name: "Adicq",
          dsc: "Padrão nacional de qualidade",
          src: `${this.baseUrl}/images/omint/busca/adicq.jpg`
        },
        {
          name: "Apalc",
          dsc: "Padrão nacional de qualidade",
          src: `${this.baseUrl}/images/omint/busca/apalc.jpg`
        },
        {
          name: "Acba",
          dsc: "Padrão internacional de qualidade",
          src: `${this.baseUrl}/images/omint/busca/acba.jpg`
        },
        {
          name: "Aqg",
          dsc: "Padrão internacional de qualidade",
          src: `${this.baseUrl}/images/omint/busca/aqg.jpg`
        },
        {
          name: "R",
          dsc: "Profissional com residência",
          src: `${this.baseUrl}/images/omint/busca/r.jpg`
        },
        {
          name: "N",
          dsc: "Comunicação de eventos adversos",
          src: `${this.baseUrl}/images/omint/busca/n.jpg`
        },
        {
          name: "P",
          dsc: "Profissional com especialização",
          src: `${this.baseUrl}/images/omint/busca/p.jpg`
        },
        {
          name: "Q",
          dsc: "Qualidade monitorada",
          src: `${this.baseUrl}/images/omint/busca/q.jpg`
        },
        {
          name: "E",
          dsc: "Título de Especialista",
          src: `${this.baseUrl}/images/omint/busca/e.jpg`
        }
      ];
      return qa;
    },
    name() {
      return this.detalhePrestador?.Nome ?? "";
    },
    redeComplementar() {
      return "";
    },
    address1() {
      const e = this.detalhePrestador?.Endereco;
      if (!e || !e.Logradouro) return "";

      const numero = e.Numero !== undefined && e.Numero !== null ? `${e.Numero}`.trim() : "";
      const complemento = `${e.Complemento ?? e.EnderecoComplemento ?? ""}`.trim();

      return [e.Logradouro.trim(), numero, complemento].filter(Boolean).join(", ");
    },
    address2() {
      const e = this.detalhePrestador?.Endereco;
      if (!e || !e.Bairro) return "";
      return [e.Bairro, e.Cidade, e.Uf]
        .map(value => (value !== undefined && value !== null ? `${value}`.trim() : ""))
        .filter(Boolean)
        .join(" - ");
    },
    idioms() {
      const idiomas = this.detalhePrestador?.Idiomas;
      const idiomasLista = Array.isArray(idiomas) ? idiomas : idiomas ? [idiomas] : [];

      return idiomasLista
        .flatMap(lang => (lang || "").split(","))
        .map(lang => lang.trim())
        .filter(Boolean);
    },
    v24() {
      return Number.parseInt(localStorage.getItem("native_version")) >= 24;
    },
    locationTypeParse() {
      const locationLabel = {
        "Perto do meu trabalho": "do seu trabalho",
        "Perto da minha casa": "da sua casa",
        "Sua localização atual": "da sua localização atual",
        "Busca por região": "da sua busca por região"
      };

      return locationLabel[this.locationType] ?? "da sua localização atual";
    },
    redesSociais() {
      const base = [
        { Tipo: "instagram", Link: null },
        { Tipo: "facebook", Link: null },
        { Tipo: "linkedin", Link: null },
        { Tipo: "youtube", Link: null },
        { Tipo: "twitter", Link: null },
        { Tipo: "spotify", Link: null }
      ];

      const redes = this.detalhePrestador?.RedesSociais;
      if (!redes) return base;

      return base.map(item => {
        const key = item.Tipo.charAt(0).toUpperCase() + item.Tipo.slice(1);
        if (redes[key]) {
          item.Link = redes[key];
        }
        return item;
      });
    }
  },
  methods: {
    ...mapActions("affiliate", [
      "fetchDoctorsInfo",
      "addAffiliateView",
      "obterDetalhesPrestador",
      "deletarFavorito",
      "salvarFavorito",
      "fetchSubstitutes"
    ]),
    ...mapMutations("affiliate", ["SET_REDE"]),
    goTo(destiny) {
      globalThis.window.open(destiny);
    },
    phoneLink(phone) {
      return `tel:${String(phone ?? "").replace(/\D/g, "")}`;
    },
    goToRedeSocial(redeSocial) {
      if (redeSocial?.Link && redeSocial.Link.startsWith("https")) {
        this.gotoSite(redeSocial.Link);
      }
    },
    async gotoSite(link) {
      if (!link) return;
      if (this.onNative) {
        const yesOrNo = await Swal.fire({
          title: "Aviso",
          text: "Você será redirecionado para um site externo. Deseja continuar?",
          confirmButtonText: "Continuar",
          cancelButtonText: "Cancelar",
          showCancelButton: true
        });
        if (!yesOrNo.value) return;
        link = `${link}${link.includes("?") ? "&" : "?"}type=.pdf`;
      }
      globalThis.window.open(link, "_blank");
    },
    changeFavorite() {
      if (this.favorite) {
        this.deletarFavorito({
          prestador: this.CdPrestador
        });
      } else {
        this.salvarFavorito({
          prestador: this.CdPrestador,
          endereco: this.SrEndereco
        });
      }
      this.favorite = !this.favorite;
      this.detalhePrestador.Favorito = this.favorite;
    },
    async redirectWhats(fone) {
      if (!fone) return;
      fone = fone.replaceAll("(", "");
      fone = fone.replaceAll(")", "");
      fone = fone.replaceAll("-", "");
      fone = fone.replaceAll(" ", "");
      const link = `https://wa.me/55${fone}`;
      if (this.isMobile) {
        globalThis.window.location = `${link}?text=Ol%C3%A1`;
      } else {
        globalThis.window.open(link, "_blank");
      }
    },
    async showSubstitutes() {
      await this.$root.$emit("show-loading");
      await this.fetchSubstitutes();
      this.$router.push({ name: "affiliate.docs" });
      await this.$root.$emit("hide-loading");
    },
    async printScreen() {
      this.qualificacoesAccordionIndex = 0;
      setTimeout(() => {
        globalThis.window.print();
      }, 350);
    },
    async showPlansAttended() {
      this.$router.push({ name: "affiliate.plansAttended", params: { nomePrestador: this.name } });
    }
  }
};
</script>

<style>
.pictures-swiper .swiper-slide > div {
  padding: 0 !important;
  max-width: 100%;
}

.pictures-swiper .swiper-slide > div img {
  height: 120px;
}

.doctor-spec-list li::marker {
  font-size: 8px;
}

.accordion-item button:hover,
.accordion-item button:focus,
.accordion-item button:focus-visible {
  background: transparent;
  box-shadow: none;
  outline: none;
}

@media print {
  body,
  html {
    height: auto !important;
  }

  .doctors-info-print {
    height: auto !important;
    min-height: auto !important;
    width: auto !important;
    overflow: visible !important;
  }

  .header-page,
  .header-page + div,
  .footer-fixed,
  .footer-fixed-margin {
    display: none !important;
  }
}
</style>
